<template>
  <div>
    <div class="row pl-3 mb-3">
      <div class="mt-3">
        <div class="card mr-0 pb-0">
          <div v-if="scope=='public_b'" class="content-box" style="">
            <div class="title">B2B业务数据集
            </div>
            <div class="content">
              <label>规模庞大的高商业价值的B2B业务数据集，覆盖多种应用场景，可上传到广告平台实现精准投放，开箱即用。</label>
            </div>
          </div>
          <div v-else class="content-box" style="">
            <div class="title">B2C业务数据集
            </div>
            <div class="content">
              <label>覆盖B2C业务多种应用场景，可上传到广告平台实现精准投放，开箱即用。支持个性化定制，支持批量下载。</label>
            </div>
          </div>
          <div class="content pt-1">
            <label>业务类型：</label>
            <el-radio-group v-model="scope" @change="radio_change">
              <el-radio label="public_b">B2B</el-radio>
              <el-radio label="public_c">B2C</el-radio>
            </el-radio-group>
          </div>
          <div class=" pt-1">
            <el-button type="warning" size="mini" @click="go_back()">返回首页</el-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="listLoading" class="bg-white">
      <div class="h-420">
        <div class="loading_position">
          <i class="el-icon-loading" style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
          <span class="d-block">加载中...</span>
        </div>
      </div>
    </div>
    <div v-else-if="pkgList.length == 0">
      <div class="h-435">
        <div class="loading_position">
          <span class="d-block">无数据，请重试</span>
        </div>
      </div>
    </div>
    <div v-if="pkgList.length > 0" class="row pl-3">
      <div class="pt-2 pb-2">
        <el-pagination layout="total, prev, pager, next" @current-change="pagechange"
                       :page-size="this.page.size" :total="this.page.total"
                       :current-page="this.page.index+1">
        </el-pagination>
      </div>
    </div>
    <div class="row pr-2">
      <div v-for="(item,index) in pkgList" class="float-left pl-2 pb-2">
        <div class="dataset-card el-card is-always-shadow card-body">
          <div class="image-container" @click="show_item_detail(item)">
            <img :src="getImageUrl(item)" alt="主图">
          </div>
          <h6 class="cursor-pointer pt-3" @click="show_item_detail(item)">{{ item.name }}</h6>
          <p v-if="item.remark" class="card-text">
            {{ item.remark.length > 20 ? item.remark.substring(0, 20) + " ..." : item.remark }}</p>
          <p v-else class="card-text">通过AI模型从大数据平台挖掘生成该数据集</p>
          <div class="mb-2">
            <el-tag type="primary" effect="dark" size="mini"><i
                class="el-icon-office-building"></i>&nbsp;{{ Math.round(item.entCount / 10000) + '万' }}
            </el-tag>
            <el-tag type="success" effect="dark" size="mini"><i
                class="el-icon-s-custom"></i>&nbsp;{{ Math.round(item.humCount / 10000) + '万' }}
            </el-tag>
            <!--
            <el-tag type="info" effect="dark" size="mini"><i
                class="el-icon-phone"></i>&nbsp;{{ Math.round(item.md5Count / 10000) + '万' }}
            </el-tag>
            -->
          </div>
          <!--
              <div class="text-muted">最后更新: {{ item.addtime|formatDateTime }}</div>
          -->
          <div>
            <el-button type="" size="mini" @click="show_item_detail(item)">查看详情</el-button>
            <el-button type="" size="mini" @click="show_export(item)">下载</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="数据集" :visible.sync="dlg_pkg_use" width="96%" :close-on-click-modal="true">
      <div v-for="(item,index) in this.sltPkg.folderList" class="pb-3">
        <div class="font-weight-bold">
          {{ item.name }}
          <!--
          <el-tag @click="search_action(item)" class="cursor-pointer mr-2" size="small">查看</el-tag>
          -->
        </div>
        <div>
          <div>{{
              item.remark
            }}
          </div>
          <span v-if="item.entCount>0">企业数量：<font color="orange">{{
              item.entCount.toLocaleString()
            }}</font>家，</span>
          <span v-if="item.humCount>0">人群数量：<font color="orange">{{
              item.humCount.toLocaleString()
            }}</font>人，</span>
          <span v-if="item.md5Count>0">MD5数据：<font color="orange">{{
              item.md5Count.toLocaleString()
            }}</font>条</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="导出" :visible.sync="dlg_export_model" width="96%" :close-on-click-modal="true">
      <el-form ref="form" :model="form" label-width="50px">
        <el-form-item label="邮箱">
          <el-input v-model="form.email" placeholder="请输入接收数据的邮箱" class="item_w">
          </el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.desc" class="item_w"></el-input>
        </el-form-item>
        <el-form-item label="筛选">
          <el-switch v-model="form.delivery"></el-switch>
        </el-form-item>
        <el-form-item v-if="form.delivery" label="地区">
          <el-select v-model="form.adProvs" placeholder="请选择省份" multiple class="item_w"
                     clearable v-on:change="getProv($event)">
            <el-option v-for="item in provs" :key="item.value" :label="item.label"
                       :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.delivery" label="年龄">
          <el-date-picker v-model="form.date_range" type="monthrange" align="left" class="item_w"
                          start-placeholder="开始" end-placeholder="结束" :picker-options="birthOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="form.delivery" label="性别">
          <el-radio v-model="form.gender" label="male">男性</el-radio>
          <el-radio v-model="form.gender" label="female">女性</el-radio>
          <el-radio v-model="form.gender" label="">不限</el-radio>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary">立即提交</el-button>
          <el-button @click.native="dlg_share=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/rest";
import util from "../../api/util";
import EntList from "../../components/EntList";
import HomeHeader from "../../components/HomeHeader.vue";

export default {
  components: {HomeHeader, EntList},
  data() {
    return {
      apiUrl: api.profile.getApiUrl(),
      title_add_pkg: "添加数据集",
      loading_info: "",
      step_index: 0,
      sysAdmin: false,
      birthOptions: util.setting.getPickeAgeOpt(),
      provs: util.setting.getProvs(),
      menuLoading: false,
      dlg_pkg_use: false,
      dlg_edit_item: false,
      dlg_export_model: false,
      dlg_ent_hum_detail: false,
      fldlistLoading: false,
      humlistLoading: false,
      ent_hum_list: [],
      pkgForm: {
        addType: 0,
        fldId: '',
        name: '',
        size: 1000,
      },
      item: {},
      folderList: [],
      pkgList: [],
      dataList: [],
      page: {
        total: 0,
        index: 0,
        size: 20,
      },
      fld_page: {
        total: 0,
        index: 0,
        size: 100,
      },
      draw_page: {
        total: 0,
        index: 0,
        size: 20,
      },
      form: {
        type: [],
        provinces: [],
        query: "",
        date_range: [],
        date_field: "birthDay",
        tags: [],
        adProv: "",
        adProvs: [],
        typeJoinList: [],
        indusList: [],
        scaleList: [],
        query_field: "name",
        delivery: true,
      },
      dlg_pkg_detail: false,
      scope: 'public_b',
      sltPkg: {},
      listLoading: false,
      dlg_loading: false,
    }
  },
  methods: {
    go_back() {
      window.location = "/"
    },
    btn_cancel() {
      this.form = {
        provinces: [],
        query: "",
        date_range: [],
        date_field: "birthDay",
        tags: [],
        query_field: "name",
      }
    },
    btn_add_new() {
      this.title_add_pkg = "添加数据集"
      this.dlg_edit_item = true
      this.sltPkg = {
        folderList: [],
        scope: this.scope
      }
    },
    radio_change() {
      this.page = {
        total: 0,
        index: 0,
        size: 20,
      }
      this.getPkgList()
    },
    getImageUrl(val) {
      if (val.img == null) {
        return this.apiUrl + "/files/img/pkg/1744013303857.png"
      } else {
        return this.apiUrl + "/files/img/pkg/" + val.img
      }
    },
    getImageList(val) {
      if (val.img == null) {
        return
      }
      let imagList = []
      var img_url = this.apiUrl + "/files/img/pkg/" + val.img
      let item = {name: val.name, url: img_url}
      imagList.push(item)
      return imagList
    },
    show_item_detail(item) {
      this.sltPkg = item
      this.dlg_pkg_use = true
    },
    show_export(item) {
      this.sltPkg = item
      this.dlg_export_model = true
    },
    search_action(fldItem) {
      let para = this.draw_page
      para.id = fldItem.id
      let api_url = "/search/rawQuery"
      this.dlg_pkg_detail = true
      this.fldlistLoading = true
      api.remote.doPost(para, api_url).then((res) => {
        this.fldlistLoading = false
        this.dataList = res.content;
        this.draw_page.total = res.totalElements
      }).catch((res) => {
        this.fldlistLoading = false
        api.handError.action(this, res);
      });
    },
    edit_item(item) {
      this.title_add_pkg = "修改数据集"
      if (item.folders != '' && item.folders != null) {
        if (typeof item.folders === 'string') {
          item.folders = item.folders.split(',').map(e => parseInt(e))
        }
      } else {
        item.folders = []
      }
      this.sltPkg = item
      console.log(item)
      this.dlg_edit_item = true
    },
    update_pkg() {
      let para = this.sltPkg
      if (Array.isArray(para.folders)) {
        para.folders = para.folders.join()
      }
      delete para.folderList
      let api_url = "/pkg/add"
      api.remote.doPost(para, api_url).then((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status
        })
        this.dlg_edit_item = false;
      }).catch((res) => {
        this.addLoading = false
        api.handError.action(this, res)
      })
    },
    pagechange(val) {
      this.page.index = val - 1;
      this.getPkgList()
    },
    btn_run_query(val) {
      this.page.index = 0;
      this.search_action();
    },
    step_pre() {
      this.step_index > 0 ? this.step_index -= 1 : this.step_index -= 0
    },
    step_next() {
      this.step_index >= 3 ? this.step_index += 0 : this.step_index += 1
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    upload_success(response, file, fileList) {
      if (response.status == 'success') {
        this.sltPkg.img = response.content
      }
    },
    btn_add_goods() {

    },
    close_dlg() {

    },
    handlePreview() {

    },
    getPhoneNumber(hum_id,md5) {
      let para = {
        "id": hum_id,
        "md5": md5
      }
      let api_url = "/search/humPhoneDec"
      api.remote.doPost(para, api_url).then((res) => {
        console.log(res)
        if (res.status == 'error') {
          this.$message({
            title: '',
            message: res.message,
            type: res.status
          })
        } else {
          this.$message({
            title: '',
            message: res,
            type: 'success'
          })
        }
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    getHumDetail(row) {
      let postData = {
        index: 0,
        size: 200,
      }
      if (row.uni_code == null) {
        postData['cid'] = row.cid
      } else {
        postData['uni_code'] = row.uni_code
      }
      let api_url = '/slice/humQuery'
      this.loading_info = '加载中...'
      this.dlg_hum_detail_title = row.company_name
      this.dlg_ent_hum_detail = true
      this.humlistLoading = true
      this.ent_hum_list = []
      api.remote.doPost(postData, api_url).then((res) => {
        // 排序
        res.content.sort(function (a, b) {
          function getScore(a) {
            if (a.typeJoin == null) {
              if (a.name == null || a.name == "未知") {
                return 0.0
              } else {
                return 45.0
              }
            }
            let score_a = 0.0
            if (a.typeJoin.some(element => element.includes("副董事长"))) {
              score_a += 40.0
            } else if (a.typeJoin.some(element => element.includes("董事长"))) {
              score_a += 50.0
            } else if (a.typeJoin.some(element => element.includes("董事会"))) {
              score_a += 50.0
            } else if (a.typeJoin.some(element => element.includes("总"))) {
              score_a += 40.0
            } else if (a.typeJoin.some(element => element.includes("经理"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("法人"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("负责人"))) {
              score_a += 35.0
            } else if (a.typeJoin.some(element => element.includes("股东"))) {
              score_a += 30.0
            } else if (a.typeJoin.some(element => element.includes("独立董事"))) {
              score_a += 9
            } else if (a.typeJoin.some(element => element.includes("董事"))) {
              score_a += 10.0
            } else if (a.typeJoin.some(element => element.includes("监事会主席"))) {
              score_a += 8.0
            } else if (a.typeJoin.some(element => element.includes("监事长"))) {
              score_a += 5.0
            } else if (a.typeJoin.some(element => element.includes("监事"))) {
              score_a += 0.0
            }
            return score_a
          }

          let score_a = getScore(a)
          let score_b = getScore(b)

          if (a.share != null) {
            score_a += parseFloat(a.share.replace("%", ""))
          }
          if (b.share != null) {
            score_b += parseFloat(b.share.replace("%", ""))
          }
          return score_b - score_a
        });
        this.humlistLoading = false
        this.ent_hum_list = res.content

      }).catch((res) => {
        this.dlg_ent_hum_detail = false
        this.humlistLoading = false
        api.handError.action(this, res);
      });
    },
    handleCurrentChange(val) {
      this.draw_page.index = val - 1;
      this.search_action();
    },
    getPkgList() {
      this.listLoading = true;
      this.pkgList = []
      let para = {
        ...this.page
      }
      let api_url = '/menu/pkglist'
      para.scope = this.scope
      this.listLoading = true;
      api.remote.doPost(para, api_url).then((res) => {
        this.pkgList = res.content;
        this.page.total = res.totalElements
        this.listLoading = false
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    getFolderList() {
      let para = {
        ...this.fld_page
      }
      let api_url = '/folder/list'
      this.menuLoading = true;
      api.remote.doPost(para, api_url).then((res) => {
        this.folderList = res.content;
        this.menuLoading = false
      }).catch((res) => {
        this.menuLoading = false;
        api.handError.action(this, res);
      });
    },

  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    }
  },
  mounted() {
    this.getPkgList()
    // this.getFolderList()
    var user = api.storage.get('user')
    if (user != null) {
      let roles = api.storage.get('user').roles
      if (roles.indexOf('SYSADMIN') != -1) {
        this.sysAdmin = true
      }
    }
  }
}
</script>
<style scoped>

.row {
  padding-right: 0px;
  padding-left: 0px;
  margin-left: 0px;
  margin-right: 0px;
  background-color: white;
}

.content {
  margin-bottom: 0.5rem !important;
}

.dataset-card {
  width: 161px;
  padding: 10px;
}

@media (min-width: 880px) {
  .dataset-card {
    width: 230px;
  }
}

.item_w {
  width: 240px;
}


.image-container {
  width: 100%;
  position: relative;
  padding-bottom: 120%; /* 高度为宽度的 1.5 倍 */
}

.image-container img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// Pkg.vue?421acfb6